import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CommentList from "./CommentList";
import CommentAdd from "./CommentAdd";

export default function Post(props) {
  const commentAdded = () => {
  setShowComments(true)
    setaddedCount(addedCount + 1);
  };
  const [addedCount, setaddedCount] = useState(0);
  const [showComments, setShowComments] = useState(false);
  return (
    <li>
      <div class="timeline-body">
        <div class="timeline-header">
          <span class="userimage">
            <img alt="" src={`api/General/Image/${props.userName}`} />
          </span>
          <span class="username">
            <a href="javascript:;">{props.Lang=='ar' ? props.nameArabic : props.nameEnglish }</a> <small />
          </span>
          <span class="pull-right text-muted">{props.createDate}</span>
        </div>
        <div class="timeline-content">
          <p>{props.message}</p>
        </div>

        <div class="timeline-comment-box">
          <div>
            <a  
              onClick={e => {
                setShowComments(true);
                e.preventDefault();
              }}
              className="text-center"
            >
              {props.commentCount} Comments
            </a>
            {showComments && (
              <CommentList
              Lang={props.Lang}
              postaddedCount={props.postaddedCount}
                addedCount={addedCount}
                crsnum={props.crsnum}
                ID={props.id}
              />
            )}
          </div>
          <CommentAdd
          Lang={props.Lang}
            commentAdded={commentAdded}
            crsnum={props.crsnum}
            ID={props.id}
          />
        </div>
      </div>
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/pages/course/Community/Post.js